import {useState, useEffect} from "react";
import {Link} from "react-router-dom";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import ChangeLanguage from "components/ChangeLanguage";
import {jwtDecode} from "jwt-decode";
import {useNotification} from "context/NotificationContext"; // Para notificações
import { useLanguage } from "context/LanguageContext";

import "./styleds.scss";

const Header = ({lista}) => {
  const { GetTranslation } = useLanguage();

  const [Show, setShow] = useState(false);
  const [userName, setUserName] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({name: "", email: "", password: ""});
  const showNotification = useNotification();

  // Função para obter o token e decodificar o nome do usuário
  const getUserFromToken = () => {
    const token = localStorage.getItem("token"); // Obtém o token do localStorage
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserName(decoded.sub.name); // Define o nome do usuário
        setFormData({name: decoded.sub.name, email: decoded.sub.email}); // Preenche os campos
      } catch (error) {
        console.error("Erro ao decodificar o token JWT:", error);
      }
    }
  };

  useEffect(() => {
    getUserFromToken();
  }, []);

  // Função para abrir o modal
  const handleUserClick = () => {
    setShowModal(true);
  };

  // Função para fechar o modal
  const hideModal = () => {
    setShowModal(false);
  };

  // Função para salvar os dados do usuário
  const handleSave = () => {
    const token = localStorage.getItem("token");

    // Remove a senha se o campo estiver vazio
    const bodyData = {
      name: formData.name,
      email: formData.email,
    };

    if (formData.senha) {
      bodyData.password = formData.senha;
    }

    fetch(`${process.env.REACT_APP_API_URL}/update_user`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, // Certifique-se de que o token está no formato correto
      },
      body: JSON.stringify(bodyData),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw new Error(err.error);
          });
        }
        return response.json();
      })
      .then((data) => {
        showNotification({
          type: "success",
          message: "Salvo com sucesso! Se deslogue para aplicar as alterações",
        });
        hideModal();
      })
      .catch((error) => {
        console.error("Erro ao salvar:", error);
        showNotification({
          type: "error",
          message: "Erro ao salvar os dados!",
        });
      });
  };

  // Função para manipular mudanças nos campos do formulário
  const handleInputChange = (e) => {
    const {name, value} = e.target;
    setFormData((prev) => ({...prev, [name]: value}));
  };

  return (
    <>
      {Show && (
        <div className="layout-navigation-mobile">
          <ul>
            {lista.map((item) => (
              <li key={item.name}>
                <Link to={item.to} onClick={() => setShow((e) => !e)}>
                  <i className={item.icon}></i> {item.name}
                </Link>
              </li>
            ))}
          </ul>
          <div className="btn-x-layout-navigation-mobile">
            <Button
              onClick={() => setShow((e) => !e)}
              icon="pi pi-times"
              rounded
              outlined
              severity="danger"
              aria-label="Cancel"
            />
          </div>
        </div>
      )}

      <header className="header">
        <div />
        <div>
          <div className="box-btns-menu-header">
            <ChangeLanguage notLabel />
            <div className="box-btn-mobile">
              <button
                type="button"
                className="btn-none"
                onClick={() => setShow((e) => !e)}
              >
                <i className="bi bi-list"></i>
              </button>
            </div>
            <div
              className="user-profile"
              onClick={handleUserClick}
              style={{cursor: "pointer", marginLeft: "auto"}} // Move o perfil para a direita
            >
              <i
                className="bi bi-person-circle"
                style={{marginRight: "5px"}}
              ></i>
              {userName && <span>{userName}</span>}
            </div>
          </div>
        </div>
      </header>

      {/* Modal para editar o perfil */}
      <Dialog
        header={GetTranslation("Meu_Perfil")}
        visible={showModal}
        style={{width: "30vw"}}
        onHide={hideModal}
      >
        <div className="d-flex flex-column gap-3" style={{width: "100%"}}>
          <div className="d-flex flex-column">
            <label htmlFor="name">{GetTranslation("Nome")}</label>
            <input
              id="name"
              name="name"
              type="text"
              className="p-inputtext"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Digite o nome"
              style={{ width: '100%' }}
            />
          </div>
          <div className="d-flex flex-column">
            <label htmlFor="email">{GetTranslation("Email")}</label>
            <input
              id="email"
              name="email"
              type="email"
              className="p-inputtext"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Digite o email"
              style={{ width: '100%' }}
            />
          </div>
          <div className="d-flex flex-column">
            <label htmlFor="password">{GetTranslation("password")}</label>
            <input
              id="password"
              name="senha"
              type="password"
              className="p-inputtext"
              value={formData.password}
              onChange={handleInputChange}
              placeholder="Digite a nova senha"
              style={{ width: '100%' }}
            />
          </div>
          <div className="d-flex justify-content-end">
            <Button label={GetTranslation("Salvar")} icon="pi pi-check" onClick={handleSave} />
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default Header;
